export const footerText = `The Benchmark School - Student Portal © ${(new Date()).getFullYear()}`;
